import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { Switch } from 'react-router';
import { Router, Route } from 'react-router-dom';
import { createHashHistory } from 'history';
import Login from './containers/Login';
import AuthorizedRoutes from './containers/AuthorizedRoutes';

const theme = createMuiTheme({
	palette: {
		primary: { main: '#1e4068' },
		secondary: green
	},
	status: {
		danger: 'orange',
	},
	typography: {
		useNextVariants: true,
	},
});


const history = createHashHistory();

// const FAKE_DEV_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkRldiBVc2VyIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

class App extends Component {

	constructor(props) {
		super(props);

		// this.mockLoginForDevelopment();

		this.inflateLoginContainer = this.inflateLoginContainer.bind(this);
		this.inflateAuthorizedRoutesContainer = this.inflateAuthorizedRoutesContainer.bind(this);
	}

	//   mockLoginForDevelopment() {
	//     // A variável 'NODE_ENV' é injetada pelo React (Create React App)
	//     // e será 'development' quando você roda com 'npm start'.
	//     const token = this.getToken();
	//     // Se não houver token, define o nosso token falso.
	//     if (!token) {
	//       console.log("DEV MODE: Mocking login with fake token.");
	//       localStorage.setItem("token", FAKE_DEV_TOKEN);
	//     }
	//   }

	isLoggedIn() {
		let loginToken = localStorage.getItem('token');
		return loginToken && loginToken.length > 0;
	}

	getToken() {
		return localStorage.getItem('token');
	}

	destroyToken() {
		localStorage.removeItem('token');
	}

	loginSuccess(token) {

		if (token) {
			localStorage.setItem('token', token);
		}

		history.push({ pathname: '/' });
	}

	redirectToLogin() {
		history.push({ pathname: '/login' });
	}

	inflateLoginContainer() {
		return (
			<Login
				isLoggedIn={this.isLoggedIn}
				loginSuccess={this.loginSuccess} />
		);
	}

	inflateAuthorizedRoutesContainer() {
		return (
			<AuthorizedRoutes
				isLoggedIn={this.isLoggedIn}
				redirectToLogin={this.redirectToLogin}
				getToken={this.getToken}
				destroyToken={this.destroyToken}
				history={history}
			/>
		);
	}

	render() {
		return (
			<MuiThemeProvider theme={theme}>
				<Router history={history}>
					<Switch>
						<Route path="/login" component={this.inflateLoginContainer} />
						<Route path="/" component={this.inflateAuthorizedRoutesContainer} />
						<Route render={() => {
							return <h2>Not Found</h2>
						}} />
					</Switch>
				</Router>
			</MuiThemeProvider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js